import React, { useContext, useEffect, useState, Fragment, useMemo, useCallback } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { TableSectionV2 } from 'components/UI';
import localization from 'assets/localization/localization';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';
import Layout from '../../../components/sales/layout/layout';
import { toast } from 'react-toastify';
import Images from '../../../assets/images/imageData';
import ListFilters from '../../sales/ListFilters/ListFilters';

const UserHelpdeskListing = ({
  userHelpdeskListing,
  helpdeskListDetails = [],
  userconfigStatus,
  userconfigstatusDetails = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const history = useHistory();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getFilter = await JSON.parse(localStorage.getItem('help_desk_users'));
      if (getFilter !== {}) {
        await userHelpdeskListing(1, getFilter);
      } else {
        await userHelpdeskListing();
      }
      setIsLoading(false);
    })();
  }, []);

  const callUserConfigStatus = useCallback(async (data) => {
    setIsLoading(true);
    await userconfigStatus({
      id: data?.id,
      status: data?.check === true ? 1 : 2,
    });
    setIsLoading(false);
  }, [userconfigStatus]);

  const buildRowActions = useCallback(
    (row) => [
      {
        name: 'Edit',
        link: `${baseUrl}/edit-config/${row.id}`,
      },
    ],
    [baseUrl]
  );

  const tableColumns = useMemo(
    () => [
      {
        key: 'user_name',
        label: 'Username',
        format: (_, row) =>
          row.user_name != null && row.user_name !== ''
            ? `${row.user_name} (${row.user_email})`
            : '—',
      },
      {
        key: 'a1_approver_name',
        label: 'First Approver Name',
        format: (_, row) =>
          row.a1_approver_name != null && row.a1_approver_name !== ''
            ? `${row.a1_approver_name} (${row.a1_approver_email})`
            : '—',
      },
      {
        key: 'a2_approver_name',
        label: 'Second Approver Name',
        format: (_, row) =>
          row.a2_approver_name != null && row.a2_approver_name !== ''
            ? `${row.a2_approver_name} (${row.a2_approver_email})`
            : '—',
      },
      {
        key: 'status',
        label: 'Status',
        format: (val, row) => (
          <span className="check-slider">
            <input
              type="checkbox"
              checked={val === 'Active'}
              onChange={(e) => {
                callUserConfigStatus({
                  check: e.target.checked,
                  id: row.id,
                  status: val,
                });
              }}
            />
            <span className="slider-status">
              <span></span>
            </span>
          </span>
        ),
      },
      {
        key: 'actions',
        label: 'Action',
        getActions: (row) => buildRowActions(row),
      },
    ],
    [buildRowActions, callUserConfigStatus]
  );

  const onPageChange = async (val) => {
    setIsLoading(true);
    await userHelpdeskListing(val.selected + 1, filterData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (userconfigstatusDetails?.status !== undefined) {
      if (parseInt(userconfigstatusDetails?.status) === 200) {
        toast.success(userconfigstatusDetails?.message);
        setTimeout(() => {
          window.location.reload();
        }, 150);
      } else if (parseInt(userconfigstatusDetails?.status) === 400) {
        toast.warning(userconfigstatusDetails?.message);
      }
    }
  }, [userconfigstatusDetails]);

  useEffect(() => {
    if (helpdeskListDetails && helpdeskListDetails.data && helpdeskListDetails.data.length > 0) {
      setListData(helpdeskListDetails.data);
      setPageCount(Math.ceil(helpdeskListDetails.total / helpdeskListDetails.per_page));
      helpdeskListDetails.current_page && setCurrentPage(helpdeskListDetails.current_page);
    } else if (helpdeskListDetails?.data !== undefined) {
      setListData([]);
      setPageCount(0);
    }
  }, [helpdeskListDetails]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (appliedFilterData) => {
    localStorage.setItem('help_desk_users', JSON.stringify(appliedFilterData));
    setIsLoading(true);
    setFilterData(appliedFilterData);
    setListData([]);
    await userHelpdeskListing(1, appliedFilterData);
    setIsLoading(false);
    filterToggle();
  };

  const srNo =
    helpdeskListDetails?.from ??
    (helpdeskListDetails?.current_page && helpdeskListDetails?.per_page
      ? (helpdeskListDetails.current_page - 1) * helpdeskListDetails.per_page + 1
      : 1);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => {
            history.push(`${baseUrl}/config-helpdesk`);
          }}
          className="filter-hamburger btn btn-transparent"
        >
          {localization.configuration}
        </Button>
        <Button onClick={filterToggle} className="filter-hamburger show-btn btn btn-transparent">
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.helpdeskListing}
      isLoading={isLoading}
      Buttons={headerBtns}
      isGoback={true}
      useNewHeaderLayout
    >
      <TableSectionV2
        hideHeader
        hideTitleAndStatusFilter
        className="site-dashboard-table-section"
        tableData={listData}
        tableColumns={tableColumns}
        tableSectionProps={{ srNo }}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isLoading={isLoading}
        emptyMessage="No users found."
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        helpdeskUserFilter={true}
        localstorageKey={'help_desk_users'}
      />
    </Layout>
  );
};

export default UserHelpdeskListing;
